import { useNavigate } from 'react-router-dom';
import useAsyncEffect from 'use-async-effect';
import ROUTES from '@constants/routes';
import { useEventContext } from '@providers/EventProvider';
import ParticipantsService from '@services/ParticipantsService';
import { env } from 'env';
import React from 'react';
import { setStorageValue } from '@helpers/storage';
import { StorageTypes, StorageValues } from '@interfaces/storage';
import GenericFullLoadingPage from '@core/myta/pages/GenericFullLoadingPage';

const { REACT_APP_EXTERNAL_EVENT_TAG } = env;

const ExternalEventPage = () => {
  const navigate = useNavigate();
  const { setLaunchArgs } = useEventContext();

  useAsyncEffect(async () => {
    const urlParams = Array.from(
      new URLSearchParams(window.location.search).entries(),
    );
    const eventTagEntry = urlParams.find(
      (entry) => entry[1] === REACT_APP_EXTERNAL_EVENT_TAG,
    );
    const eventTag =
      eventTagEntry && eventTagEntry.length > 0 ? eventTagEntry[1] : '';

    console.log(`External event tag: ${eventTag}`);

    if (!eventTag) {
      return navigate(ROUTES.SELECT_EVENT);
    }

    const participantEvents =
      await ParticipantsService.getCurrentParticipantEvents();
    const externalEvent = participantEvents.events.find((pe) =>
      pe?.event?.eventTags?.includes(eventTag),
    );

    if (!externalEvent) {
      return navigate(ROUTES.SELECT_EVENT);
    }

    const externalEventId = externalEvent.eventId;

    // Get any launch args from URL params to be sent to UE
    const formattedParams = urlParams.map(([key, value]) => `-${key}=${value}`);
    setLaunchArgs(formattedParams);

    console.log(`Navigating to external event ${externalEventId}`);

    setStorageValue(
      StorageValues.ExtraLaunchArgs,
      JSON.stringify({ eventId: externalEventId, launchArgs: formattedParams }),
      StorageTypes.Session,
    );

    return navigate(ROUTES.EVENT_PAGE(externalEventId), {
      replace: true,
      state: {
        isExternalEvent: true,
      }
    });
  }, [setLaunchArgs]);

  return <GenericFullLoadingPage isAuthorized />;
};

export default ExternalEventPage;
